// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CloseSideNavButton: 'close-side-nav-button',
	ContentHeader: 'content-header',
	MainMenu: 'main-menu',
	InboxMenu: 'inbox-menu',
	SettingsMenu: 'settings-menu',
	HomeLink: 'home-link',
	AddFileButton: 'add-file-button',
	CloseSideNavDiv: 'close-side-nav-div',
} as const;
